import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-174">
      <div className="max-w-2xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#FFF8F0] rounded-2xl md:rounded-3xl p-5 md:p-14 shadow-xl border border-[#F5E6DC] relative overflow-hidden" data-id="element-176">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#D4A853] rounded-full opacity-5 blur-3xl" data-id="element-177" />

          <div className="relative z-10" data-id="element-178">
            <div className="flex justify-center mb-3 md:mb-6" data-id="element-179">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-[#D4A853] rounded-full flex items-center justify-center shadow-lg" data-id="element-180">
                <ShieldCheckIcon className="w-8 md:w-10 h-8 md:h-10 text-white" data-id="element-181" />
              </div>
            </div>

            <p className="text-sm uppercase tracking-[0.2em] text-[#D4A853] font-bold mb-2 md:mb-3" data-id="element-182">
              Sin riesgo para ti
            </p>

            <h2 className="font-['Playfair_Display'] text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4 md:mb-8" data-id="element-183">
              Garantía total de <span className="text-[#D4A853]" data-id="element-184">7 días</span>
            </h2>

            <p className="text-lg md:text-xl text-[#2D2D2D] leading-relaxed mb-5 md:mb-8 max-w-lg mx-auto" data-id="element-185">
              Aplica los 3 interruptores. Si no notas diferencia,{' '}
              <span className="font-bold text-[#E8734A]" data-id="element-186">
                te devuelvo cada centavo.
              </span>{' '}
              Sin preguntas.
            </p>

            <div className="bg-[#2D2D2D] rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg" data-id="element-187">
              <p className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-188">
                El riesgo es mío.
              </p>
              <p className="text-lg md:text-xl font-bold text-[#D4A853]" data-id="element-189">
                El beneficio es tuyo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}